import React from "react";
import {cx} from "../../lib/ClassSet";
import StatusTag from "../../components/StatusTag";
import {ORDER_TYPES} from "../forms/OrderTaggingRuleForm";


function orderTypeName(id) {
  const orderType = ORDER_TYPES.find((t) => t.get("id") === id);
  return orderType ? orderType.get("name") : id;
}

function accountLabel(data) {
  const customer = data.get("customerName") || data.get("customerEmail");
  const account = data.get("accountName");
  if (customer && account) return `${customer} (${account})`;
  return customer || account || data.get("accountId");
}

const OrderTaggingRuleItem = (props) => {

  let {data} = props;
  const enabled = data.get("status") === "enabled";

  let classes = cx({
    "item": true,
    "order-tagging-rule-list-item": true,
    "u-selected": props.selected,
    "u-inactive": !enabled,
  });

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-title">{data.get("title")}</td>
      <td className="field f-account" title={data.get("accountId")}>{accountLabel(data)}</td>
      <td className="field f-order-types">{data.get("orderTypes").map(orderTypeName).join(", ")}</td>
      <td className="field f-id f-nolink">{data.get("skuPattern")}</td>
      <td className="field f-tags">
        {data.get("tags").map((tag) =>
          <StatusTag key={tag} color={StatusTag.COLORS.BLUE} noMargin>{tag}</StatusTag>
        )}
      </td>
      <td className="field f-status">
        <StatusTag color={enabled ? StatusTag.COLORS.GREEN : StatusTag.COLORS.GREY} noMargin>{data.get("status")}</StatusTag>
      </td>
    </tr>
  )
}

export default OrderTaggingRuleItem;
